/**
 * WebApi
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type OfferDocuments = 'OfferDocs' | 'RejectionDocs' | 'RejectionDocsPerItem';

export const OfferDocuments = {
    OfferDocs: 'OfferDocs' as OfferDocuments,
    RejectionDocs: 'RejectionDocs' as OfferDocuments,
    RejectionDocsPerItem: 'RejectionDocsPerItem' as OfferDocuments
};

